module.exports = __webpack_public_path__ + "static/gotowka-1c0638d6526226450a3f8a95483b1fb5.jpg";